import { isRejected, isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';
import type { ErrorPayload } from '../types';
import { notify } from '@app/providers/notification/notification';
import i18n from '@shared/services/i18n/i18n';

interface CustomError {
  data: {
    detail: string;
  };
  status: number;
}

export const rtkQueryErrorHandler: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const errorPayload = action.payload as CustomError;

    if (errorPayload?.status !== 404) {
      notify({
        message: errorPayload?.data?.detail || i18n.t('common.commonErrors.offlineError'),
      });
    }
  }

  if (isRejected(action)) {
    const errorPayload = action.payload as ErrorPayload;
    if (errorPayload?.status === 403) {
      console.warn(i18n.t('common.commonErrors.accessDenied'), errorPayload);
    }
  }
  return next(action);
};
